// Consistent loading / empty / error snippets used across screens.

import { esc } from './dom';

export const loadingHtml = (label = 'Yükleniyor…'): string =>
  `<div class="state"><div class="spinner" style="margin:0 auto 12px"></div>${esc(label)}</div>`;

export const emptyHtml = (emoji: string, label: string): string =>
  `<div class="state"><div class="state__emoji">${emoji}</div>${esc(label)}</div>`;

export const errorHtml = (message: string): string =>
  `<div class="state"><div class="state__emoji">⚠️</div>${esc(message)}</div>`;
